import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [operator, setOperator] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('operator');
    if (stored) setOperator(JSON.parse(stored));
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await authService.login(email, password);
    if (data.account_type === 'client') {
      localStorage.removeItem('token');
      localStorage.removeItem('operator');
      localStorage.setItem(`portal_${data.tenant_slug}`, data.token);
      setOperator(null);
      return data;
    }
    localStorage.setItem('token', data.token);
    localStorage.setItem('operator', JSON.stringify(data.operator));
    setOperator(data.operator);
    return data;
  };

  const registerPlayer = async (fields) => {
    const { data } = await authService.registerPlayer(fields);
    localStorage.removeItem('token');
    localStorage.removeItem('operator');
    localStorage.setItem(`portal_${data.tenant_slug}`, data.token);
    setOperator(null);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('operator');
    setOperator(null);
  };

  return (
    <AuthContext.Provider value={{ operator, login, registerPlayer, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
